export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'hot',
    name: '热门推荐',
    description: '精选当下最受欢迎的成人漫画作品，每日更新热门榜单，让你不错过任何精彩内容。',
    icon: 'ri-fire-line',
    articleCount: 128,
  },
  {
    slug: 'japanese',
    name: '日漫专区',
    description: '汇集日本经典成人漫画，涵盖多种题材与风格，满足不同读者的阅读偏好。',
    icon: 'ri-earth-fill',
    articleCount: 356,
  },
  {
    slug: 'korean',
    name: '韩漫专区',
    description: '韩国成人漫画以精致的画风和细腻的情节著称，为你带来沉浸式阅读体验。',
    icon: 'ri-map-pin-line',
    articleCount: 214,
  },
  {
    slug: 'chinese',
    name: '国漫专区',
    description: '国内优秀成人漫画作品汇聚地，支持原创作者，发现本土漫画的魅力。',
    icon: 'ri-china-railway-line',
    articleCount: 89,
  },
  {
    slug: 'western',
    name: '欧美专区',
    description: '欧美成人漫画风格独特、表现力强，提供英文原版和中文翻译版本。',
    icon: 'ri-global-line',
    articleCount: 145,
  },
  {
    slug: '3d',
    name: '3D漫画',
    description: '采用3D渲染技术制作的成人漫画，画面逼真、场景震撼，带来全新的视觉体验。',
    icon: 'ri-shapes-line',
    articleCount: 67,
  },
  {
    slug: 'doujin',
    name: '同人作品',
    description: '丰富的同人创作作品，涵盖热门IP的二次创作，想象力丰富、创意无限。',
    icon: 'ri-brush-line',
    articleCount: 203,
  },
  {
    slug: 'completed',
    name: '完结作品',
    description: '已完结的成人漫画作品全集，一次性畅读到底，无需追更等待。',
    icon: 'ri-check-double-line',
    articleCount: 178,
  },
  {
    slug: 'guide',
    name: '使用教程',
    description: '禁漫天堂平台的完整使用指南，包括注册登录、功能操作、常见问题等实用教程。',
    icon: 'ri-book-open-line',
    articleCount: 24,
  },
];